import { useEffect } from "react";
import { EspaceTemps } from "./charts/EspaceTemps";
import { Profil } from "./charts/Profil";
import { MapView } from "./map/MapView";
import { useApp } from "./state/store";
import { Bandeau } from "./ui/Bandeau";
import { Detail } from "./ui/Detail";
import { EnTete } from "./ui/EnTete";
import { Methode } from "./ui/Methode";
import { Onglets } from "./ui/Onglets";
import { Outils } from "./ui/Outils";
import { PanneauGare } from "./ui/PanneauGare";
import { Reglages } from "./ui/Reglages";

export function App() {
  const load = useApp((s) => s.load);
  const error = useApp((s) => s.error);
  const route = useApp((s) => s.route);
  const selected = useApp((s) => s.selected);
  const onglet = useApp((s) => s.onglet);
  const reglages = useApp((s) => s.reglagesOuverts);
  const detail = useApp((s) => s.detailOuvert);

  useEffect(() => {
    void load();
  }, [load]);

  const large = onglet === "profil" || onglet === "espace";
  return (
    <div className="app">
      <Bandeau />
      <main className={"app-main" + (large ? " large" : "")}>
        <MapView />
        <aside className="panneau" aria-live="polite">
          {error && <p className="erreur">Impossible de charger le tracé : {error}</p>}
          {!route && !error && <p className="chargement">Chargement du tracé…</p>}
          {route && (
            <>
              <EnTete />
              {selected !== null && <PanneauGare />}
              <Onglets />
              {reglages && <Reglages />}
              {onglet === "gares" && (
                <>
                  <Outils />
                  {detail && <Detail />}
                </>
              )}
              {onglet === "profil" && <Profil />}
              {onglet === "espace" && <EspaceTemps />}
              {onglet === "methode" && <Methode />}
            </>
          )}
        </aside>
      </main>
    </div>
  );
}
